import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/parts/actions/applications";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  APPLICABLE_ID,
  LOWER_ASSEMBLY_APPLICATION
} from "MODULES/parts/constants";
import Applicable from "./Applicable";

const FORM_NAME = "createPartApplication";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Field
          name={APPLICABLE_ID}
          component={Applicable}
          type={props.type}
          afterChange={props.updateType}
          formName={FORM_NAME}
        />
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  type: PropTypes.string.isRequired,
  updateType: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(actions.createApplication(ownProps.id, ownProps.type, data))
}))(
  form({
    form: FORM_NAME,
    validate: (values, ownProps) =>
      validator(values, f => {
        if (ownProps.type !== LOWER_ASSEMBLY_APPLICATION) {
          f.validate(APPLICABLE_ID).satisfies(rules.required);
        } else {
          f
            .validate("Reciprocal")
            .satisfies(rules.requiresAtLeast(1, "label", APPLICABLE_ID));
        }
      })
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Applications/Form.jsx